// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610231039/js/" + chunkId + "." + {"44":"fc3d2d51","225":"9d9c43a3","481":"56d3855f","486":"ab45b204","770":"5144a001"}[chunkId] + ".0.3634910030355919.chunk.js";
};